// 
// shopTheLookCta.js
//

define([
    'jquery',
    'Handlebars',
    'handlebars-core',
    'pubsub',
    'vfdp.shopTheLookEvents',
    'wcs.utils',
    'wcs.context',
    'wcs.product-price-service'
],function($, Handlebars, HandlebarsCore, pubsub, Events, utils, ctx, priceService) {

    // Name the plugin
    var PLUGIN_IDENTIFIER = 'shopTheLookCta';
    var DEBUG = false;

    // Create the function that will be bound to JQuery
    var vfdpPlugin = function(element, options) {
        this.element = element;
        this.options = options;
    };

    vfdpPlugin.prototype = {
        defaults : {
            template: 'html.shop-the-look.stl-banner-cta',
            targetContainer: '.viewer-wrapper',
            mobileTargetContainer: '.product-actions',
            ctaContainer: '.cta-container',
            ctaContainerDesktopClass: 'cta-container-position-desktop',
            ctaContainerMobileClass: 'cta-container-position-mobile',
            ctaEnabledClass: 'cta-enabled',
            initialContextElement: '.attr-box.selected img',
            currentDataOptions: {},
            modal: 'stl-modal',
            modalBackgroundContainer: '.top-container',
            autoLoadEnabled: true,
            ctaLabelEnabled: false,
            iconBeforeLabel: false,
            differentMobileContainerEnabled: false,
            ctaLabel: 'Shop the Look', //label passed to CTA when ctaLabelEnabled = true
            stlLaunchWithUrlEnabled: false
        },

        /**
         * init()
         * Acts as constructor to initialize our Class
         */
        init: function() {
            if(DEBUG) console.log(PLUGIN_IDENTIFIER, ' init()');
            var self = this;

            // Merge various methods of providing plugin options into a single config object
            self.metadata = $(self.element).data(PLUGIN_IDENTIFIER + 'Options');
            self.stlConfig = $(self.metadata.initialContextElement).data('stlConfig');

            self.config = $.extend(
                {}, // empty object to merge into
                self.defaults, // defaults hardcoded into the prototype defined in this file
                self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
                self.metadata, // options provided as HTML data attribute $(selector).data()
                self.stlConfig
            );

            self.productData = $(self.config.initialContextElement).data('productData');
            self.productData.productId = $(self.config.initialContextElement).data('productId');
            self.productData.productTitle = $(self.config.initialContextElement).data('productTitle');
            self.productData.productPartNumber = $(self.config.initialContextElement).data('part-number');

            var $productForm = $('.product-form-js');
            self.productData.masterCategoryIdentifier = $productForm.data('master-category-identifier');
            self.productData.seoCategory = $productForm.data('seo-category');

            var trackingDataContainer = $('.tracking-product-data-js');
            if(trackingDataContainer.length > 0) {
                var trackingData = trackingDataContainer.data().trackingProductDataServiceOptions;
                if( trackingData ) {
                    self.productData.avgRating = trackingData.avgRating;
                    self.productData.numReviews = trackingData.numReviews;
                    self.productData.price = trackingData.price;
                }
            }

            Events.init(self);
            Events.defaults.bundleId = self.config.bundleId;
            Events.defaults.storeId = self.config.storeId;

            self.events();

            if(self.config.autoLoadEnabled) {
                self._build();
            }

            // Allow JQuery-style chaining of the plugin
            return self;
        },

        /**
         * build()
         * Builds our DOM structure
         */
        _build: function() {
            var self = this;

            return self.loadAndCompileTemplate().done(function(){
                self.retrieveStlBundleAvailability(self.stlConfig);
            });
        },

        /**
         * render()
         * Renders our Handlebars template.
         * @param {Object} data - the data you wish to render
         */
        render: function(data) {
            var self = this;
            var selector = self.config.targetContainer;
            if (self.config.differentMobileContainerEnabled) {
                selector += ', ' + self.config.mobileTargetContainer;
            }
            $(selector).find(self.config.ctaContainer).remove();
            if (data) {
                $(selector).addClass(self.config.ctaEnabledClass);
                $(selector).append(self.compiledTemplate(data));
                if (self.config.differentMobileContainerEnabled) {
                    $(self.config.targetContainer).find('> ' + self.config.ctaContainer).addClass(self.config.ctaContainerDesktopClass);
                    $(self.config.mobileTargetContainer).find('> ' + self.config.ctaContainer).addClass(self.config.ctaContainerMobileClass);
                }
                if (self.config.stlLaunchWithUrlEnabled && utils.getParamFromHash('stlOpen') == 'true') {
                    $(selector).find(self.config.ctaContainer).find('button').click();
                }
            } else {
                $(selector).removeClass(self.config.ctaEnabledClass);
            }
        },

        /**
         * retrieveStlBundleAvailability()
         * Retrieve STL bundle availability data and hide the STL CTA if no associate product from the bundle is available
         * @param {Object} stlConfig - the stlConfig data you wish to render
         */
        retrieveStlBundleAvailability: function(stlConfig) {
            var self = this;

            if (!stlConfig || !stlConfig.availabilityBaseURL) {
                return self.render(stlConfig);
            }

            if(DEBUG) console.log('getProductAvailability: ', stlConfig.availabilityBaseURL);

            return $.ajax({
                url: stlConfig.availabilityBaseURL,
                data: {
                    langId: ctx.getLangId(),
                },
                context: this,
                async: false
            }).done(function(data) {
                self.stlBundleAvailability = data.response.Bundle;
                var pdpProductId = self.productData.productId || $(self.element).data('product-id');
                var bundleProductsAvailability = false;
                $.each(self.stlBundleAvailability, function(ind,prod) {
                    var product = prod.product,
                        productId  =  product.id;
                    // skip the product from the PDP that triggers the STL CTA
                    if (pdpProductId && pdpProductId.toString() === productId.toString()) {
                        return;
                    }
                    bundleProductsAvailability = bundleProductsAvailability || product.availability;
                });
                self.render(bundleProductsAvailability ? stlConfig : null);
            }).fail(function(error) {
                if(DEBUG) console.error('Failed to load ', stlConfig.availabilityBaseURL);
                return self.render(stlConfig);
            });
        },

        updateURLHistory : function(isSTLOpen) {
            var self = this;
            if (DEBUG) console.log('updateURLHistory ', isSTLOpen);

            if (self.config.stlLaunchWithUrlEnabled) {
                var state = {
                    stlOpen: isSTLOpen
                };
                history.replaceState(state, null, utils.setMultipleURLParams(state, true));
            }
        },

        /**
         * events()
         * Attaches the event listeners
         */
        events: function() {
            var self = this;

            $.pubsub('unsubscribe', this.swatchClickEventToken);
            $.pubsub('unsubscribe', this.colorSwatchClickEventToken);

            // When a swatch is clicked render() will either remove or update the STL CTA based on the swatch config
            self.swatchClickEventToken = $.pubsub('subscribe', 'product-form.attr.swatch.click', function(event, data) {
                self.currentDataOptions = $(data.target).data('stlConfig');
                self.retrieveStlBundleAvailability(self.currentDataOptions);
            });

            // This is only case with TBL, when the color swatch is also making an ajax and updating the DOM.
            self.colorSwatchClickEventToken = $.pubsub('subscribe', 'WCS.PRODUCTFORM.COLORWAY_PRODUCT.FORM_UPDATE', function (event, data) {
                self.currentDataOptions = $(self.defaults.initialContextElement).data('stlConfig');
                self.retrieveStlBundleAvailability(self.currentDataOptions);
            });

            //GTM DataLayer Events
            // Set stlOpen to true in url hash to handle launching the modal on page load
            $('#' + self.config.modal).on('open.zf.reveal', function() {
                if(DEBUG) console.log("Shop the look modal opened");
                self.updateURLHistory(true);
            });

            // Set stlOpen to false in url hash
            $('#' + self.config.modal).on('closed.zf.reveal', function() {
            try {
                if(DEBUG) console.log("Shop the look modal closed");
                if (!window.stlModalAddToCartClick) {
                  Events.createDataLayerEvent('loadEventData', 'modalClose', 'STL', 'Close Modal Click');
                }
                window.stlModalAddToCartClick = false;
                self.updateURLHistory(false);
                // Hide any error message
                $('#' + self.config.modal).find('.tooltipstered').tooltipster('hide');
            } catch(e) {
                console.error(e);
            }
        });
     }
};

    // Create the instance defaults from the prototype
    vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;
    vfdpPlugin.prototype = $.extend({}, HandlebarsCore, vfdpPlugin.prototype);

    // Register as a JQuery plugin and prevent duplicate instantiation
    $.fn[PLUGIN_IDENTIFIER] = function (options) {
        return this.each(function () {
            var instance = $(this).data(PLUGIN_IDENTIFIER);
            if (!instance) {
                instance = new vfdpPlugin(this, options).init();
                $(this).data(PLUGIN_IDENTIFIER, instance);
            }
        });
    };
});
